export default [
  "/stadium1.jpeg",
  "/stadium2.jpeg",
  "/stadium3.jpeg",
  "/stadium4.jpeg",
  "/stadium5.jpeg",
  "/stadium6.jpeg",
  "/stadium7.jpeg",
  "/stadium8.jpeg",
  "/stadium9.jpeg",
  "/stadium10.jpeg",
]